import { render, staticRenderFns } from "./Disable.vue?vue&type=template&id=37cbb85a&scoped=true"
import script from "./Disable.vue?vue&type=script&lang=js"
export * from "./Disable.vue?vue&type=script&lang=js"
import style0 from "./Disable.vue?vue&type=style&index=0&id=37cbb85a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cbb85a",
  null
  
)

export default component.exports